import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userService } from '../../_services';

class ResendEmailPage extends React.Component
{
    constructor(props){
        super(props); 

        this.state = {
            email : '' ,
            disableSubmit : false 
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event){
        this.setState ({
            [event.target.name] : event.target.value  //update state of corresponding input name 
        })
    }

    handleSubmit(event){
        event.preventDefault();

        this.setState({
            disableSubmit : true
        });

        userService.resendEmail(this.state);
    }

    render(){
        let {email} = this.state; 

        const disableSubmit = this.state.disableSubmit ? 'disabled' : '' ; 

        return (
            <div>
                <div className="columns">
                    <div className="column is-6">
                        <h3 className="title">Resend Email</h3>
                    </div>
                </div>
                
                <form onSubmit={this.handleSubmit}>
                    <div className="field">
                        <div className="control m-t-lg">
                            <div className="level">
                                <div className="level-left control-label">Email Address</div>
                            </div>
                            <input className="input" type="email" name="email" value={email} onChange={this.handleChange} placeholder="" />
                        </div>
                        
                       
                        <div className="control m-t-lg">
                            <input type="submit" disabled={disableSubmit} className="button button-submit"/>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { loading } = state;
    return {
        loading 
    };
}

const connectedResendEmailPage = connect(mapStateToProps)(ResendEmailPage);
export { connectedResendEmailPage as ResendEmailPage }; 



// WEBPACK FOOTER //
// ./src/Views/ResendEmailPage/ResendEmailPage.jsx